import { render } from "./App.vue?vue&type=template&id=7dbcf284"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7dbcf284&lang=css"

import exportComponent from "/codebuild/output/src1309399801/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__